/* global axios */
import WhatsAppSipApiClient from './index';

class WhatsAppSipHolidaysAPI extends WhatsAppSipApiClient {
  constructor() {
    super('holidays');
  }

  get() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, { holiday: data });
  }

  update(id, data) {
    return axios.put(`${this.url}/${id}`, { holiday: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new WhatsAppSipHolidaysAPI();
